import { AppButton, AppTextField } from 'components';
import useESTList from 'hooks/API/GET/useESTList';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import useDebounce from 'hooks/useDebounce';
import ESTDeleteModal from './manage/ESTDeleteModal';
import TablePaginate from 'components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import * as AppPics from 'assets/images';

import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { useHistory } from 'react-router-dom';

function ManageEST() {
  const history = useHistory();
  const [search, handleSearch] = useState('');
  const [params, setParams] = usePaginateDefaults();
  const [deleteQModal, handleDeleteQModal] = useState(Object.assign({}, DELETE_EST_MODAL_CONFIG));

  const searchKeyword = useDebounce(search, 1000);

  const {
    isLoading,
    data: tableData,
    isError,
  } = useESTList({ enabled: true, configs: { params: { ...params, keyword: searchKeyword } } });
  const { meta: { page = 1, total } = {} } = tableData?.data ?? {};

  return (
    <Fragment>
      <ESTDeleteModal
        modalConfig={deleteQModal}
        closeModal={() => handleDeleteQModal(Object.assign({}, DELETE_EST_MODAL_CONFIG))}
      />
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={() => history.push('/curriculum')}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Curriculum', to: '/curriculum' },
                ]}
                current="Regions"
              />
            </div>
            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">Manage Regions</h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Regions..."
                          type="text"
                          value={search}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="flex items-center gap-10">
                    <Link to="/manage/est/add">
                      <button className="btn-left-content add">Add Region</button>
                    </Link>
                  </div>
                </div>

                <div className="tableWrap">
                  <div className="table-responsive">
                    <table className="table tableWrap__table">
                      <thead className="thead-light __appTheadColor">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col" className="w25">
                            Name
                          </th>
                          <th scope="col" className="w25">
                            Unique key{' '}
                          </th>
                          <th scope="col" className="w25">
                            Status
                          </th>
                          <th scope="col" className="align-center">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        'Loading...'
                      ) : isError ? (
                        'Failed to load data'
                      ) : tableData?.data?.result?.length > 0 ? (
                        <tbody>
                          {tableData?.data?.result?.map((result, index) => {
                            return (
                              <tr key={result._id}>
                                <th scope="row">{index + 1}</th>
                                <td>{result.name}</td>
                                <td>{result.key}</td>
                                <td>{result?.status}</td>
                                <td className="align-center">
                                  <Link
                                    to={`/manage/est/edit/${result?._id}`}
                                    className="actions-icons mx-2"
                                  >
                                    <img src={AppPics.EditSvg} alt="edit this option" />
                                  </Link>
                                  <AppButton
                                    className="actions-icons mx-2 text-danger"
                                    onClick={() =>
                                      handleDeleteQModal(() => ({
                                        show: true,
                                        data: { estID: result?._id },
                                      }))
                                    }
                                  >
                                    <img src={AppPics.DeleteSvg} alt="delete this option" />
                                  </AppButton>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        'No records found'
                      )}
                    </table>
                  </div>
                </div>

                <TablePaginate
                  maxCount={total}
                  currentPage={page}
                  defaultLimit={params.limit}
                  setPage={(page) => setParams((x) => ({ ...x, page }))}
                  handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const DELETE_EST_MODAL_CONFIG = {
  show: false,
  data: {
    id: null,
  },
};

export default ManageEST;
